export const questionTypes = {
  numeric: 'question_numeric',
  scale: 'question_scale',
  rating: 'question_rating',
  yesNo: 'question_yesNo',
  multipleChoice: 'question_multiple_choice',
  openQuestion: 'question_open',
  pictureChoice: 'question_pictureChoice',
};

export const newQuestionTypes = {
  openQuestion: 'question_open',
  address: 'question_address',
  date: 'question_date',
  phone: 'question_phone',
  text: 'question_text',
  numeric: 'question_numeric',
  scale: 'question_scale',
  rating: 'question_rating',
  nps: 'question_nps',
  multipleChoice: 'question_multipleChoice',
  singleChoice: 'question_singleChoice',
  yesNo: 'question_yesNo',
  fileUpload: 'question_fileUpload',
  pictureChoice: 'question_pictureChoice',
  quiz: 'question_quiz',
  choice: 'question_choice',
  likert: 'question_likert',
  media: 'media_item',
};

export const newQuestionInfoData = {
  openQuestion: '?',
  address: 'Only accepts answer as address fields',
  date: 'Only accepts answer as calendar dates',
  phone:
    'Ask for a phone number. Your respondent choose from a list of country codes for the right format',
  text: 'Engage your audience with open text to give feedbacks, comments, etc',
  numeric: 'Only accept answers as numbers',
  scale: 'Give your audience a numbered scale to choose from',
  rating: 'Let your audience the possibility to give quality feedback',
  nps: 'Use Net Promoter Score (NPS) to ask your audience a quality notation',
  multipleChoice:
    'Create a question with multiple answers. Set the button multiple selection if several answers are possible',
  singleChoice:
    'Give your audience one option to answer among many and display the possible answers in tags mode',
  yesNo: 'Give your audience the options to answer by Yes or No',
  fileUpload:
    'Ask for any type of file up to 10MB, like a photo, PDF or spreadsheet or upload a document to send to your audience',
  pictureChoice: 'Give image options to choose from',
  quiz:
    'Create interactive quiz to evaluate your audience understanding or to check the knowledge maturity before an e-consent signature',
  likert: 'Create a likert question',
  media: 'Create a question with a video or an audio file',
};

export const questionTypesData = {
  [questionTypes.numeric]: {
    type: questionTypes.numeric,
    text: 'Numeric',
  },
  [questionTypes.scale]: {
    type: questionTypes.scale,
    text: 'Scale',
  },
  [questionTypes.rating]: {
    type: questionTypes.rating,
    text: 'Rating',
  },
  [questionTypes.yesNo]: {
    type: questionTypes.yesNo,
    text: 'Yes/No',
  },
  [questionTypes.multipleChoice]: {
    type: questionTypes.multipleChoice,
    text: 'Multiple choice',
  },
  [questionTypes.openQuestion]: {
    type: questionTypes.openQuestion,
    text: 'Open question',
  },
  [questionTypes.fileUpload]: {
    type: questionTypes.fileUpload,
    text: 'File upload',
  },
  [questionTypes.likert]: {
    type: questionTypes.likert,
    text: 'Likert question',
  },
  [questionTypes.media]: {
    type: questionTypes.media,
    text: 'Media',
  },
};

export const newQuestionTypesData = {
  [newQuestionTypes.openQuestion]: {
    type: newQuestionTypes.openQuestion,
    text: 'Open question',
    icon: 'newsletter',
    info: newQuestionInfoData.openQuestion,
    isJam: true,
  },
  [newQuestionTypes.address]: {
    type: newQuestionTypes.address,
    text: 'Address',
    icon: 'newsletter',
    info: newQuestionInfoData.address,
    isJam: true,
    disabled: true,
  },
  [newQuestionTypes.date]: {
    type: newQuestionTypes.date,
    text: 'Date',
    icon: 'calendar',
    info: newQuestionInfoData.date,
    isJam: true,
  },
  [newQuestionTypes.phone]: {
    type: newQuestionTypes.phone,
    text: 'Phone',
    icon: 'phone',
    info: newQuestionInfoData.phone,
    isJam: true,
    disabled: true,
  },
  [newQuestionTypes.numeric]: {
    type: newQuestionTypes.numeric,
    text: 'Numeric',
    icon: 'grid',
    info: newQuestionInfoData.numeric,
    isJam: true,
  },
  [newQuestionTypes.scale]: {
    type: newQuestionTypes.scale,
    text: 'Scale',
    icon: 'more-horizontal',
    info: newQuestionInfoData.scale,
    isJam: true,
  },
  [newQuestionTypes.rating]: {
    type: newQuestionTypes.rating,
    text: 'Rating',
    icon: 'star',
    info: newQuestionInfoData.rating,
    disabled: true,
  },
  [newQuestionTypes.nps]: {
    type: newQuestionTypes.nps,
    text: 'NPS',
    icon: 'users',
    info: newQuestionInfoData.nps,
    isJam: true,
    disabled: true,
  },
  [newQuestionTypes.singleChoice]: {
    type: newQuestionTypes.singleChoice,
    text: 'Single choice',
    icon: 'circle',
    info: newQuestionInfoData.singleChoice,
    isJam: true,
  },
  [newQuestionTypes.yesNo]: {
    type: newQuestionTypes.yesNo,
    text: 'Yes/No',
    icon: 'check-circle',
    info: newQuestionInfoData.yesNo,
    disabled: true,
  },
  [newQuestionTypes.multipleChoice]: {
    type: newQuestionTypes.multipleChoice,
    text: 'Multiple choice',
    icon: 'check',
    info: newQuestionInfoData.multipleChoice,
    isJam: true,
  },
  [newQuestionTypes.pictureChoice]: {
    type: newQuestionTypes.pictureChoice,
    text: 'Picture choice',
    icon: 'picture',
    info: newQuestionInfoData.pictureChoice,
    isJam: true,
    disabled: true,
  },
  [newQuestionTypes.likert]: {
    type: newQuestionTypes.likert,
    text: 'Likert question',
    icon: 'grid',
    info: newQuestionInfoData.likert,
    isJam: true,
  },
};

export const newQuestionnaireQuestionTypesData = {
  [newQuestionTypes.date]: {
    type: newQuestionTypes.date,
    text: 'Date',
    icon: 'calendar',
    info: newQuestionInfoData.date,
    isJam: true,
  },
  [newQuestionTypes.media]: {
    type: newQuestionTypes.media,
    text: 'Media',
    icon: 'video',
    info: newQuestionInfoData.date,
  },
  [newQuestionTypes.openQuestion]: {
    type: newQuestionTypes.openQuestion,
    text: 'Open question',
    icon: 'newsletter',
    isJam: true,
    disabled: false,
  },
  [newQuestionTypes.nps]: {
    type: newQuestionTypes.nps,
    text: 'NPS',
    icon: 'users',
    isJam: true,
    disabled: true,
  },
  [newQuestionTypes.numeric]: {
    type: newQuestionTypes.numeric,
    text: 'Numeric',
    icon: 'grid',
    isJam: true,
  },
  [newQuestionTypes.scale]: {
    type: newQuestionTypes.scale,
    text: 'Scale',
    icon: 'more-horizontal',
    isJam: true,
  },
  [newQuestionTypes.pictureChoice]: {
    type: newQuestionTypes.pictureChoice,
    text: 'Picture choice',
    icon: 'picture',
    isJam: true,
    disabled: true,
  },
  [newQuestionTypes.rating]: {
    type: newQuestionTypes.rating,
    text: 'Rating',
    icon: 'star',
    disabled: true,
  },
  [newQuestionTypes.multipleChoice]: {
    type: newQuestionTypes.multipleChoice,
    text: 'Multiple choice',
    icon: 'check',
    isJam: true,
    disabled: false,
  },
  [newQuestionTypes.singleChoice]: {
    type: newQuestionTypes.singleChoice,
    text: 'Single choice',
    icon: 'circle',
    isJam: true,
    disabled: false,
  },
  [newQuestionTypes.yesNo]: {
    type: newQuestionTypes.yesNo,
    text: 'Yes/No',
    icon: 'check-circle',
    disabled: true,
  },
  [newQuestionTypes.fileUpload]: {
    type: newQuestionTypes.fileUpload,
    text: 'File upload',
    icon: 'upload',
    isJam: true,
    disabled: true,
  },
  [newQuestionTypes.likert]: {
    type: newQuestionTypes.likert,
    text: 'Likert question',
    icon: 'grid',
    info: newQuestionInfoData.likert,
    isJam: true,
  },
};
